export default __webpack_public_path__ + "static/media/arrow-down.727fa8f3.svg";